var Codec = require('io/codec');

var GetTopicDetailsCommand = require('./get-topic-details');
var TopicDetailsSerialiser = require('topics/details/topic-details-serialiser');

var serialiser = {
    read : function(input) {
        return TopicDetailsSerialiser.read(input);
    },
    write : function(output, request) {
        Codec.writeString(output, request.topic_name);
        Codec.writeByte(output, request.level);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/get-topic-details/get-topic-details-serialiser.js
// module id = 1034
// module chunks = 1